import React from 'react';
import styled, { css } from 'styled-components';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var DEFAULT_CVC_LENGTH = 3;
var DEFAULT_ZIP_LENGTH = 5;
var DEFAULT_CARD_FORMAT = /(\d{1,4})/g;
var CARD_TYPES = [{
  displayName: 'Visa',
  type: 'visa',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^4/,
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: 'CVV',
    length: 3
  }
}, {
  displayName: 'Mastercard',
  type: 'mastercard',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: 'CVC',
    length: 3
  }
}, {
  displayName: 'American Express',
  type: 'amex',
  format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  startPattern: /^3[47]/,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: 'CID',
    length: 4
  }
}, {
  displayName: 'Diners Club',
  type: 'dinersclub',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(36|38|30[0-5])/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: 'CVV',
    length: 3
  }
}, {
  displayName: 'Discover',
  type: 'discover',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(6011|65|64[4-9]|622)/,
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: 'CID',
    length: 3
  }
}, {
  displayName: 'JCB',
  type: 'jcb',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^35/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: 'CVV',
    length: 3
  }
}, {
  displayName: 'UnionPay',
  type: 'unionpay',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^62/,
  gaps: [4, 8, 12],
  lengths: [14, 15, 16, 17, 18, 19],
  code: {
    name: 'CVN',
    length: 3
  }
}, {
  displayName: 'Maestro',
  type: 'maestro',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(5018|5020|5038|6304|6703|6708|6759|676[1-3])/,
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: 'CVC',
    length: 3
  }
}, {
  displayName: 'Elo',
  type: 'elo',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(4011(78|79)|43(1274|8935)|45(1416|7393|763(1|2))|50(4175|6699|67[0-7][0-9]|9000)|627780|63(6297|6368)|650(03([^4])|04([0-9])|05(0|1)|4(0[5-9]|3[0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8])|9([2-6][0-9]|7[0-8])|541|700|720|901)|651652|655000|655021)/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: 'CVE',
    length: 3
  }
}, {
  displayName: 'Hipercard',
  type: 'hipercard',
  format: DEFAULT_CARD_FORMAT,
  startPattern: /^(384100|384140|384160|606282|637095|637568|60(?!11))/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: 'CVC',
    length: 3
  }
}];
var getCardTypeByValue = function getCardTypeByValue(value) {
  return CARD_TYPES.filter(function (cardType) {
    return cardType.startPattern.test(value);
  })[0];
};
var getCardTypeByType = function getCardTypeByType(type) {
  return CARD_TYPES.filter(function (cardType) {
    return cardType.type === type;
  })[0];
};

var cardTypes = /*#__PURE__*/Object.freeze({
  DEFAULT_CVC_LENGTH: DEFAULT_CVC_LENGTH,
  DEFAULT_ZIP_LENGTH: DEFAULT_ZIP_LENGTH,
  DEFAULT_CARD_FORMAT: DEFAULT_CARD_FORMAT,
  CARD_TYPES: CARD_TYPES,
  getCardTypeByValue: getCardTypeByValue,
  getCardTypeByType: getCardTypeByType
});

var formatCardNumber = function formatCardNumber(cardNumber) {
  var cardType = getCardTypeByValue(cardNumber);
  if (!cardType) return (cardNumber.match(/\d+/g) || []).join('');
  var format = cardType.format;

  if (format && format.global) {
    return (cardNumber.match(format) || []).join(' ');
  }

  if (format) {
    var execResult = format.exec(cardNumber.split(' ').join(''));

    if (execResult) {
      return execResult.splice(1, 3).filter(function (x) {
        return x;
      }).join(' ');
    }
  }

  return cardNumber;
};
var formatExpiry = function formatExpiry(event) {
  var eventData = event.nativeEvent && event.nativeEvent.data;
  var prevExpiry = event.target.value.split(' / ').join('/');
  if (!prevExpiry) return null;
  var expiry = prevExpiry;

  if (/^[2-9]$/.test(expiry)) {
    expiry = "0".concat(expiry);
  }

  if (prevExpiry.length === 2 && +prevExpiry > 12) {
    var _prevExpiry$split = prevExpiry.split(''),
        _prevExpiry$split2 = _toArray(_prevExpiry$split),
        head = _prevExpiry$split2[0],
        tail = _prevExpiry$split2.slice(1);

    expiry = "0".concat(head, "/").concat(tail.join(''));
  }

  if (/^1[/-]$/.test(expiry)) {
    return "01 / ";
  }

  expiry = expiry.match(/(\d{1,2})/g) || [];

  if (expiry.length === 1) {
    if (!eventData && prevExpiry.includes('/')) {
      return expiry[0];
    }

    if (/\d{2}/.test(expiry)) {
      return "".concat(expiry[0], " / ");
    }
  }

  if (expiry.length > 2) {
    var _ref = expiry.join('').match(/^(\d{2}).*(\d{2})$/) || [],
        _ref2 = _slicedToArray(_ref, 3),
        _ref2$ = _ref2[1],
        month = _ref2$ === void 0 ? null : _ref2$,
        _ref2$2 = _ref2[2],
        year = _ref2$2 === void 0 ? null : _ref2$2;

    return [month, year].join(' / ');
  }

  return expiry.join(' / ');
};

var formatter = /*#__PURE__*/Object.freeze({
  formatCardNumber: formatCardNumber,
  formatExpiry: formatExpiry
});

var MONTH_REGEX = /(0[1-9]|1[0-2])/;
var EMPTY_CARD_NUMBER = 'Enter a card number';
var EMPTY_EXPIRY_DATE = 'Enter an expiry date';
var EMPTY_CVC = 'Enter a CVC';
var EMPTY_ZIP = 'Enter a ZIP code';
var INVALID_CARD_NUMBER = 'Card number is invalid';
var INVALID_EXPIRY_DATE = 'Expiry date is invalid';
var INVALID_CVC = 'CVC is invalid';
var MONTH_OUT_OF_RANGE = 'Expiry month must be between 01 and 12';
var YEAR_OUT_OF_RANGE = 'Expiry year cannot be in the past';
var DATE_OUT_OF_RANGE = 'Expiry date cannot be in the past';
var hasCardNumberReachedMaxLength = function hasCardNumberReachedMaxLength(currentValue) {
  var cardType = getCardTypeByValue(currentValue);
  return cardType && currentValue.length >= cardType.lengths[cardType.lengths.length - 1];
};
var isNumeric = function isNumeric(e) {
  return /^\d*$/.test(e.key);
};
var validateLuhn = function validateLuhn(cardNumber) {
  return cardNumber.split('').reverse().map(function (digit) {
    return parseInt(digit, 10);
  }).map(function (digit, idx) {
    return idx % 2 ? digit * 2 : digit;
  }).map(function (digit) {
    return digit > 9 ? digit % 10 + 1 : digit;
  }).reduce(function (accum, digit) {
    return accum += digit;
  }) % 10 === 0;
};
var getCardNumberError = function getCardNumberError(cardNumber, cardNumberValidator) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$errorMessages = _ref.errorMessages,
      errorMessages = _ref$errorMessages === void 0 ? {} : _ref$errorMessages;

  if (!cardNumber) {
    return errorMessages.emptyCardNumber || EMPTY_CARD_NUMBER;
  }

  var rawCardNumber = cardNumber.replace(/\s/g, '');
  var cardType = getCardTypeByValue(rawCardNumber);

  if (cardType && cardType.lengths) {
    var doesCardNumberMatchLength = cardType.lengths.includes(rawCardNumber.length);

    if (doesCardNumberMatchLength) {
      var isLuhnValid = validateLuhn(rawCardNumber);

      if (isLuhnValid) {
        if (cardNumberValidator) {
          return cardNumberValidator({
            cardNumber: rawCardNumber,
            cardType: cardType,
            errorMessages: errorMessages
          });
        }

        return;
      }
    }
  }

  return errorMessages.invalidCardNumber || INVALID_CARD_NUMBER;
};
var getExpiryDateError = function getExpiryDateError(expiryDate, expiryValidator) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$errorMessages = _ref2.errorMessages,
      errorMessages = _ref2$errorMessages === void 0 ? {} : _ref2$errorMessages;

  if (!expiryDate) {
    return errorMessages.emptyExpiryDate || EMPTY_EXPIRY_DATE;
  }

  var rawExpiryDate = expiryDate.replace(' / ', '').replace('/', '');

  if (rawExpiryDate.length === 4) {
    var month = rawExpiryDate.slice(0, 2);
    var year = "20".concat(rawExpiryDate.slice(2, 4));

    if (!MONTH_REGEX.test(month)) {
      return errorMessages.monthOutOfRange || MONTH_OUT_OF_RANGE;
    }

    if (parseInt(year) < new Date().getFullYear()) {
      return errorMessages.yearOutOfRange || YEAR_OUT_OF_RANGE;
    }

    if (parseInt(year) === new Date().getFullYear() && parseInt(month) < new Date().getMonth() + 1) {
      return errorMessages.dateOutOfRange || DATE_OUT_OF_RANGE;
    }

    if (expiryValidator) {
      return expiryValidator({
        expiryDate: {
          month: month,
          year: year
        },
        errorMessages: errorMessages
      });
    }

    return;
  }

  return errorMessages.invalidExpiryDate || INVALID_EXPIRY_DATE;
};
var getCVCError = function getCVCError(cvc, cvcValidator) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      cardType = _ref3.cardType,
      _ref3$errorMessages = _ref3.errorMessages,
      errorMessages = _ref3$errorMessages === void 0 ? {} : _ref3$errorMessages;

  if (!cvc) {
    return errorMessages.emptyCVC || EMPTY_CVC;
  }

  if (cvc.length < 3) {
    return errorMessages.invalidCVC || INVALID_CVC;
  }

  if (cardType && cvc.length !== cardType.code.length) {
    return errorMessages.invalidCVC || INVALID_CVC;
  }

  if (cvcValidator) {
    return cvcValidator({
      cvc: cvc,
      cardType: cardType,
      errorMessages: errorMessages
    });
  }

  return;
};
var getZIPError = function getZIPError(zip) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$errorMessages = _ref4.errorMessages,
      errorMessages = _ref4$errorMessages === void 0 ? {} : _ref4$errorMessages;

  if (!zip) {
    return errorMessages.emptyZIP || EMPTY_ZIP;
  }

  return;
};

var validator = /*#__PURE__*/Object.freeze({
  EMPTY_CARD_NUMBER: EMPTY_CARD_NUMBER,
  EMPTY_EXPIRY_DATE: EMPTY_EXPIRY_DATE,
  EMPTY_CVC: EMPTY_CVC,
  EMPTY_ZIP: EMPTY_ZIP,
  INVALID_CARD_NUMBER: INVALID_CARD_NUMBER,
  INVALID_EXPIRY_DATE: INVALID_EXPIRY_DATE,
  INVALID_CVC: INVALID_CVC,
  MONTH_OUT_OF_RANGE: MONTH_OUT_OF_RANGE,
  YEAR_OUT_OF_RANGE: YEAR_OUT_OF_RANGE,
  DATE_OUT_OF_RANGE: DATE_OUT_OF_RANGE,
  hasCardNumberReachedMaxLength: hasCardNumberReachedMaxLength,
  isNumeric: isNumeric,
  validateLuhn: validateLuhn,
  getCardNumberError: getCardNumberError,
  getExpiryDateError: getExpiryDateError,
  getCVCError: getCVCError,
  getZIPError: getZIPError
});

var BACKSPACE_KEY_CODE = 'Backspace';
var ENTER_KEY_CODE = 'Enter';
var isHighlighted = function isHighlighted() {
  return (global.getSelection() || {
    type: undefined
  }).type === 'Range';
};
var utils = {
  cardTypes: cardTypes,
  formatter: formatter,
  validator: validator,
  BACKSPACE_KEY_CODE: BACKSPACE_KEY_CODE,
  ENTER_KEY_CODE: ENTER_KEY_CODE,
  isHighlighted: isHighlighted
};

function usePaymentCard() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
      errorMessages = _ref.errorMessages,
      onTouch = _ref.onTouch,
      onInput = _ref.onInput,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onError = _ref.onError,
      cardNumberValidator = _ref.cardNumberValidator,
      cvcValidator = _ref.cvcValidator,
      expiryValidator = _ref.expiryValidator;

  var cardNumberField = React.useRef();
  var expiryDateField = React.useRef();
  var cvcField = React.useRef();
  var zipField = React.useRef();
  /** ====== START: META STUFF ====== */

  var _React$useState = React.useState({
    cardNumber: false,
    expiryDate: false,
    cvc: false,
    zip: false
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      touchedInputs = _React$useState2[0],
      setTouchedInputs = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isTouched = _React$useState4[0],
      setIsTouched = _React$useState4[1];

  var _React$useState5 = React.useState({
    cardNumber: undefined,
    expiryDate: undefined,
    cvc: undefined,
    zip: undefined
  }),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      erroredInputs = _React$useState6[0],
      setErroredInputs = _React$useState6[1];

  var _React$useState7 = React.useState(),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      error = _React$useState8[0],
      setError = _React$useState8[1];

  var _React$useState9 = React.useState(),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      cardType = _React$useState10[0],
      setCardType = _React$useState10[1];

  var _React$useState11 = React.useState(),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      focused = _React$useState12[0],
      setFocused = _React$useState12[1];

  var setInputError = React.useCallback(function (input, error) {
    setErroredInputs(function (erroredInputs) {
      if (erroredInputs[input] === error) return erroredInputs;
      var newError = error;

      var newErroredInputs = _objectSpread({}, erroredInputs, _defineProperty({}, input, error));

      if (error) {
        setError(error);
      } else {
        newError = Object.values(newErroredInputs).find(Boolean);
        setError(newError);
      }

      onError && onError(newError, newErroredInputs);
      return newErroredInputs;
    });
  }, []); // eslint-disable-line

  var setInputTouched = React.useCallback(function (input, value) {
    requestAnimationFrame(function () {
      if (document.activeElement.tagName !== 'INPUT') {
        setIsTouched(true);
      } else if (value === false) {
        setIsTouched(false);
      }
    });
    setTouchedInputs(function (touchedInputs) {
      if (touchedInputs[input] === value) return touchedInputs;

      var newTouchedInputs = _objectSpread({}, touchedInputs, _defineProperty({}, input, value));

      onTouch && onTouch(_defineProperty({}, input, value), newTouchedInputs);
      return newTouchedInputs;
    });
  }, []); // eslint-disable-line

  /** ====== END: META STUFF ====== */

  /** ====== START: CARD NUMBER STUFF ====== */

  var handleFocusCardNumber = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onFocus && props.onFocus(e);
      setFocused('cardNumber');
    };
  }, []);
  var handleKeyPressCardNumber = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      var formattedCardNumber = e.target.value || '';
      var cardNumber = formattedCardNumber.replace(/\s/g, '');
      props.onKeyPress && props.onKeyPress(e);

      if (e.key !== utils.ENTER_KEY_CODE) {
        if (!utils.validator.isNumeric(e)) {
          e.preventDefault();
        }

        if (utils.validator.hasCardNumberReachedMaxLength(cardNumber)) {
          e.preventDefault();
        }
      }
    };
  }, []);
  var handleChangeCardNumber = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      var formattedCardNumber = e.target.value || '';
      var cardNumber = formattedCardNumber.replace(/\s/g, '');
      var cursorPosition = cardNumberField.current.selectionStart;
      var cardType = utils.cardTypes.getCardTypeByValue(cardNumber);
      setCardType(cardType); // @ts-ignore

      cardNumberField.current.value = utils.formatter.formatCardNumber(cardNumber);
      props.onInput && props.onInput(e);
      props.onChange && props.onChange(e);
      onInput && onInput(e);
      onChange && onChange(e); // Due to the card number formatting, the selection cursor will fall to the end of
      // the input field. Here, we want to reposition the cursor to the correct place.

      requestAnimationFrame(function () {
        if (document.activeElement !== cardNumberField.current) return;

        if (cardNumberField.current.value[cursorPosition - 1] === ' ') {
          cursorPosition = cursorPosition + 1;
        }

        cardNumberField.current.setSelectionRange(cursorPosition, cursorPosition);
      });
      var cardNumberError = utils.validator.getCardNumberError(cardNumber, cardNumberValidator, {
        errorMessages: errorMessages
      });

      if (!cardNumberError && autoFocus) {
        expiryDateField.current && expiryDateField.current.focus();
      }

      setInputTouched('cardNumber', !cardNumberError);
      setInputError('cardNumber', cardNumberError);
      props.onError && props.onError(cardNumberError);
    };
  }, [autoFocus, cardNumberValidator, errorMessages, onInput, onChange, setInputError, setInputTouched]);
  var handleBlurCardNumber = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onBlur && props.onBlur(e);
      onBlur && onBlur(e);
      setFocused(undefined);
      setInputTouched('cardNumber', true);
    };
  }, [onBlur, setInputTouched]);
  var getCardNumberProps = React.useCallback(function () {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var refKey = _ref2.refKey,
        props = _objectWithoutProperties(_ref2, ["refKey"]);

    return _objectSpread(_defineProperty({
      'aria-label': 'Card number',
      autoComplete: 'cc-number',
      id: 'cardNumber',
      name: 'cardNumber',
      placeholder: 'Card number',
      type: 'tel'
    }, refKey || 'ref', cardNumberField), props, {
      onFocus: handleFocusCardNumber(props),
      onKeyPress: handleKeyPressCardNumber(props),
      onInput: handleChangeCardNumber(props),
      onChange: handleChangeCardNumber(props),
      onBlur: handleBlurCardNumber(props)
    });
  }, [handleFocusCardNumber, handleKeyPressCardNumber, handleChangeCardNumber, handleBlurCardNumber]);
  React.useEffect(function () {
    var timeout = global.setTimeout(function () {
      if (cardNumberField.current && !cardType) {
        var formattedCardNumber = cardNumberField.current.value || '';
        var cardNumber = formattedCardNumber.replace(/\s/g, '');
        var analyzedCardType = utils.cardTypes.getCardTypeByValue(cardNumber);
        setCardType(analyzedCardType);
        clearTimeout(timeout);
      }
    }, 100);
    return function () {
      global.clearTimeout(timeout);
    };
  }, [cardType]);
  /** ====== END: CARD NUMBER STUFF ====== */

  /** ====== START: EXPIRY DATE STUFF ====== */

  var handleFocusExpiryDate = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onFocus && props.onFocus(e);
      setFocused('expiryDate');
    };
  }, []);
  var handleKeyDownExpiryDate = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onKeyDown && props.onKeyDown(e);

      if (e.key === utils.BACKSPACE_KEY_CODE && !e.target.value && autoFocus) {
        cardNumberField.current && cardNumberField.current.focus();
      }
    };
  }, [autoFocus]);
  var handleKeyPressExpiryDate = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      var formattedExpiryDate = e.target.value || '';
      var expiryDate = formattedExpiryDate.replace(' / ', '');
      props.onKeyPress && props.onKeyPress(e);

      if (e.key !== utils.ENTER_KEY_CODE) {
        if (!utils.validator.isNumeric(e)) {
          e.preventDefault();
        }

        if (expiryDate.length >= 4) {
          e.preventDefault();
        }
      }
    };
  }, []);
  var handleChangeExpiryDate = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      expiryDateField.current.value = utils.formatter.formatExpiry(e);
      props.onInput && props.onInput(e);
      props.onChange && props.onChange(e);
      onInput && onInput(e);
      onChange && onChange(e);
      var expiryDateError = utils.validator.getExpiryDateError(expiryDateField.current.value, expiryValidator, {
        errorMessages: errorMessages
      });

      if (!expiryDateError && autoFocus) {
        cvcField.current && cvcField.current.focus();
      }

      setInputTouched('expiryDate', !expiryDateError);
      setInputError('expiryDate', expiryDateError);
      props.onError && props.onError(expiryDateError);
    };
  }, [autoFocus, errorMessages, expiryValidator, onInput, onChange, setInputError, setInputTouched]);
  var handleBlurExpiryDate = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onBlur && props.onBlur(e);
      onBlur && onBlur(e);
      setFocused(undefined);
      setInputTouched('expiryDate', true);
    };
  }, [onBlur, setInputTouched]);
  var getExpiryDateProps = React.useCallback(function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var refKey = _ref3.refKey,
        props = _objectWithoutProperties(_ref3, ["refKey"]);

    return _objectSpread(_defineProperty({
      'aria-label': 'Expiry date in format MM YY',
      autoComplete: 'cc-exp',
      id: 'expiryDate',
      name: 'expiryDate',
      placeholder: 'MM/YY',
      type: 'tel'
    }, refKey || 'ref', expiryDateField), props, {
      onFocus: handleFocusExpiryDate(props),
      onKeyDown: handleKeyDownExpiryDate(props),
      onKeyPress: handleKeyPressExpiryDate(props),
      onInput: handleChangeExpiryDate(props),
      onChange: handleChangeExpiryDate(props),
      onBlur: handleBlurExpiryDate(props)
    });
  }, [handleFocusExpiryDate, handleKeyDownExpiryDate, handleKeyPressExpiryDate, handleChangeExpiryDate, handleBlurExpiryDate]);
  /** ====== END: EXPIRY DATE STUFF ====== */

  /** ====== START: CVC STUFF ====== */

  var handleFocusCVC = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onFocus && props.onFocus(e);
      setFocused('cvc');
    };
  }, []);
  var handleKeyDownCVC = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onKeyDown && props.onKeyDown(e);

      if (e.key === utils.BACKSPACE_KEY_CODE && !e.target.value && autoFocus) {
        expiryDateField.current && expiryDateField.current.focus();
      }
    };
  }, [autoFocus]);
  var handleKeyPressCVC = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref4 = arguments.length > 1 ? arguments[1] : undefined,
        cardType = _ref4.cardType;

    return function (e) {
      var formattedCVC = e.target.value || '';
      var cvc = formattedCVC.replace(' / ', '');
      props.onKeyPress && props.onKeyPress(e);

      if (e.key !== utils.ENTER_KEY_CODE) {
        if (!utils.validator.isNumeric(e)) {
          e.preventDefault();
        }

        if (cardType && cvc.length >= cardType.code.length) {
          e.preventDefault();
        }

        if (cvc.length >= 4) {
          e.preventDefault();
        }
      }
    };
  }, []);
  var handleChangeCVC = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        cardType = _ref5.cardType;

    return function (e) {
      var cvc = e.target.value;
      props.onInput && props.onInput(e);
      props.onChange && props.onChange(e);
      onInput && onInput(e);
      onChange && onChange(e);
      var cvcError = utils.validator.getCVCError(cvc, cvcValidator, {
        cardType: cardType,
        errorMessages: errorMessages
      });

      if (!cvcError && autoFocus) {
        zipField.current && zipField.current.focus();
      }

      setInputTouched('cvc', !cvcError);
      setInputError('cvc', cvcError);
      props.onError && props.onError(cvcError);
    };
  }, [autoFocus, cvcValidator, errorMessages, onInput, onChange, setInputError, setInputTouched]);
  var handleBlurCVC = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onBlur && props.onBlur(e);
      onBlur && onBlur(e);
      setFocused(undefined);
      setInputTouched('cvc', true);
    };
  }, [onBlur, setInputTouched]);
  var getCVCProps = React.useCallback(function () {
    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var refKey = _ref6.refKey,
        props = _objectWithoutProperties(_ref6, ["refKey"]);

    return _objectSpread(_defineProperty({
      'aria-label': 'CVC',
      autoComplete: 'cc-csc',
      id: 'cvc',
      name: 'cvc',
      placeholder: cardType ? cardType.code.name : 'CVC',
      type: 'tel'
    }, refKey || 'ref', cvcField), props, {
      onFocus: handleFocusCVC(props),
      onKeyDown: handleKeyDownCVC(props),
      onKeyPress: handleKeyPressCVC(props, {
        cardType: cardType
      }),
      onChange: handleChangeCVC(props, {
        cardType: cardType
      }),
      onBlur: handleBlurCVC(props)
    });
  }, [cardType, handleFocusCVC, handleKeyDownCVC, handleKeyPressCVC, handleChangeCVC, handleBlurCVC]);
  /** ====== END: CVC STUFF ====== */

  /** ====== START: ZIP STUFF ====== */

  var handleFocusZIP = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onFocus && props.onFocus(e);
      setFocused('zip');
    };
  }, []);
  var handleKeyDownZIP = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onKeyDown && props.onKeyDown(e);

      if (e.key === utils.BACKSPACE_KEY_CODE && !e.target.value && autoFocus) {
        cvcField.current && cvcField.current.focus();
      }
    };
  }, [autoFocus]);
  var handleKeyPressZIP = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onKeyPress && props.onKeyPress(e);

      if (e.key !== utils.ENTER_KEY_CODE) {
        if (!utils.validator.isNumeric(e)) {
          e.preventDefault();
        }
      }
    };
  }, []);
  var handleChangeZIP = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      var zip = e.target.value;
      props.onInput && props.onInput(e);
      props.onChange && props.onChange(e);
      onInput && onInput(e);
      onChange && onChange(e);
      var zipError = utils.validator.getZIPError(zip, {
        errorMessages: errorMessages
      });
      setInputTouched('zip', !zipError);
      setInputError('zip', zipError);
      props.onError && props.onError(zipError);
    };
  }, [errorMessages, onInput, onChange, setInputError, setInputTouched]);
  var handleBlurZIP = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (e) {
      props.onBlur && props.onBlur(e);
      onBlur && onBlur(e);
      setFocused(undefined);
      setInputTouched('zip', true);
    };
  }, [onBlur, setInputTouched]);
  var getZIPProps = React.useCallback(function () {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var refKey = _ref7.refKey,
        props = _objectWithoutProperties(_ref7, ["refKey"]);

    return _objectSpread(_defineProperty({
      autoComplete: 'off',
      id: 'zip',
      maxLength: '6',
      name: 'zip',
      placeholder: 'ZIP',
      type: 'tel'
    }, refKey || 'ref', zipField), props, {
      onFocus: handleFocusZIP(props),
      onKeyDown: handleKeyDownZIP(props),
      onKeyPress: handleKeyPressZIP(props),
      onInput: handleChangeZIP(props),
      onChange: handleChangeZIP(props),
      onBlur: handleBlurZIP(props)
    });
  }, [handleFocusZIP, handleKeyDownZIP, handleKeyPressZIP, handleChangeZIP, handleBlurZIP]);
  /** ====== END: ZIP STUFF ====== */

  /** ====== START: CARD IMAGE STUFF ====== */

  var getCardImageProps = React.useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var images = props.images || {};
    return _objectSpread({
      'aria-label': cardType ? cardType.displayName : 'Placeholder card',
      children: images[cardType ? cardType.type : 'placeholder'] || images.placeholder,
      width: '1.5em',
      height: '1em',
      viewBox: '0 0 24 16'
    }, props);
  }, [cardType]);
  /** ====== END: CARD IMAGE STUFF ====== */
  // Set default field errors

  React.useLayoutEffect(function () {
    if (zipField.current) {
      var zipError = utils.validator.getZIPError(zipField.current.value, {
        errorMessages: errorMessages
      });
      setInputError('zip', zipError);
    }

    if (cvcField.current) {
      var cvcError = utils.validator.getCVCError(cvcField.current.value, cvcValidator, {
        errorMessages: errorMessages
      });
      setInputError('cvc', cvcError);
    }

    if (expiryDateField.current) {
      var expiryDateError = utils.validator.getExpiryDateError(expiryDateField.current.value, expiryValidator, {
        errorMessages: errorMessages
      });
      setInputError('expiryDate', expiryDateError);
    }

    if (cardNumberField.current) {
      var cardNumberError = utils.validator.getCardNumberError(cardNumberField.current.value, cardNumberValidator, {
        errorMessages: errorMessages
      });
      setInputError('cardNumber', cardNumberError);
    }
  }, [cardNumberValidator, cvcValidator, errorMessages, expiryValidator, setInputError]); // Format default values

  React.useLayoutEffect(function () {
    if (cardNumberField.current) {
      cardNumberField.current.value = utils.formatter.formatCardNumber(cardNumberField.current.value);
    }

    if (expiryDateField.current) {
      expiryDateField.current.value = utils.formatter.formatExpiry({
        target: expiryDateField.current
      });
    }
  }, []); // Set default card type

  React.useLayoutEffect(function () {
    if (cardNumberField.current) {
      var _cardType = utils.cardTypes.getCardTypeByValue(cardNumberField.current.value);

      setCardType(_cardType);
    }
  }, []);
  return {
    getCardImageProps: getCardImageProps,
    getCardNumberProps: getCardNumberProps,
    getExpiryDateProps: getExpiryDateProps,
    getCVCProps: getCVCProps,
    getZIPProps: getZIPProps,
    wrapperProps: {
      error: error,
      focused: focused,
      isTouched: isTouched
    },
    meta: {
      cardType: cardType,
      erroredInputs: erroredInputs,
      error: error,
      focused: focused,
      isTouched: isTouched,
      touchedInputs: touchedInputs
    }
  };
}

function PaymentInputsContainer(props) {
  var paymentInputs = usePaymentCard(props);
  return props.children(paymentInputs);
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: #c9444d;\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        border-color: #444bc9;\n        box-shadow: #444bc9 0px 0px 0px 1px;\n        ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        border-color: #c9444d;\n        box-shadow: #c9444d 0px 0px 0px 1px;\n        ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: white;\n  border: 1px solid #bdbdbd;\n  box-shadow: inset 0px 1px 2px #e5e5e5;\n  border-radius: 0.2em;\n  display: flex;\n  height: 2.5em;\n  padding: 0.4em 0.6em;\n\n  & {\n    ", ";\n  }\n\n  & {\n    ", ";\n  }\n\n  & input {\n    border: unset;\n    margin: unset;\n    padding: unset;\n    outline: unset;\n    font-size: inherit;\n\n    & {\n      ", ";\n    }\n\n    ", ";\n  }\n\n  & svg {\n    margin-right: 0.6em;\n    & {\n      ", ";\n    }\n  }\n\n  & input#cardNumber {\n    width: 11em;\n    & {\n      ", ";\n    }\n  }\n\n  & input#expiryDate {\n    width: 4em;\n    & {\n      ", ";\n    }\n  }\n\n  & input#cvc {\n    width: 2.5em;\n    & {\n      ", ";\n    }\n  }\n\n  & input#zip {\n    width: 4em;\n    & {\n      ", ";\n    }\n  }\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n\n  & {\n    ", ";\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var FieldWrapper = styled.div(_templateObject(), function (props) {
  return props.hasErrored && props.styles.fieldWrapper ? props.styles.fieldWrapper.errored : undefined;
}, function (props) {
  return props.styles.fieldWrapper ? props.styles.fieldWrapper.base : undefined;
});
var InputWrapper = styled.div(_templateObject2(), function (props) {
  return props.hasErrored && css(_templateObject3(), function (props) {
    return props.styles.inputWrapper && props.styles.inputWrapper.errored;
  });
}, function (props) {
  return props.focused && css(_templateObject4(), function (props) {
    return props.styles.inputWrapper && props.styles.inputWrapper.focused;
  });
}, function (props) {
  return props.hasErrored && props.styles.input ? props.styles.input.errored : undefined;
}, function (props) {
  return props.styles.input && props.styles.input.base;
}, function (props) {
  return props.styles.cardImage;
}, function (props) {
  return props.styles.input && props.styles.input.cardNumber;
}, function (props) {
  return props.styles.input && props.styles.input.expiryDate;
}, function (props) {
  return props.styles.input && props.styles.input.cvc;
}, function (props) {
  return props.styles.input && props.styles.input.zip;
}, function (props) {
  return props.styles.inputWrapper ? props.styles.inputWrapper.base : undefined;
});
var ErrorText = styled.div(_templateObject5(), function (props) {
  return props.styles.errorText ? props.styles.errorText.base : undefined;
});

function PaymentInputsWrapper(props) {
  var children = props.children,
      error = props.error,
      errorTextProps = props.errorTextProps,
      focused = props.focused,
      inputWrapperProps = props.inputWrapperProps,
      isTouched = props.isTouched,
      styles = props.styles,
      restProps = _objectWithoutProperties(props, ["children", "error", "errorTextProps", "focused", "inputWrapperProps", "isTouched", "styles"]);

  var hasErrored = error && isTouched;
  return React.createElement(FieldWrapper, _extends({
    hasErrored: hasErrored,
    styles: styles
  }, restProps), React.createElement(InputWrapper, _extends({
    focused: focused,
    hasErrored: hasErrored,
    styles: styles
  }, inputWrapperProps), children), hasErrored && React.createElement(ErrorText, _extends({
    styles: styles
  }, errorTextProps), error));
}

PaymentInputsWrapper.defaultProps = {
  styles: {}
};

export { PaymentInputsContainer, PaymentInputsWrapper, getCVCError, getCardNumberError, getExpiryDateError, getZIPError, usePaymentCard as usePaymentInputs };